import { Turret } from "./Turret";
import { Engine } from "../Engine";
import { GameConstants } from "../GameConstants";
import { Enemy } from "../enemies/Enemy";
import { MathUtils } from "../utils/MathUtils";

export class BzztTurret extends Turret {

    public intensity: number[];
    public duration: number[];

    constructor (p: {r: number, c: number}, engine: Engine, skipBuild?: boolean, level?: number) {
        
        super(GameConstants.TURRET_BZZT, p, engine, skipBuild, level);

        this.calculateTurretParameters();
    }

    // mirar en el ANUTO y generar las formulas que correspondan
    protected calculateTurretParameters(): void {

        this.damage = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_DAMAGE][this.level - 1];
        this.reload = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RELOAD][this.level - 1];
        this.range =  this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RANGE][this.level - 1];
        this.priceUpgrade =  this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_PRICE_UPGRADE][this.level - 1];
        this.intensity = this.engine.turretData[this.type].intensity;
        this.duration = this.engine.turretData[this.type].duration;

        super.calculateTurretParameters();
    }  

    protected getEnemiesWithinLine(enemy: Enemy): Enemy[] {

        let newEnemies = [];

        for (let i = 0; i < this.engine.enemies.length; i ++) {

            const newEnemy = this.engine.enemies[i];

            let infiniteX = newEnemy.x + (enemy.x - this.x) * 1000;
            let infiniteY = newEnemy.y + (enemy.y - this.y) * 1000;

            if (newEnemy !== enemy && MathUtils.isLineSegmentIntersectingCircle({x: this.x, y: this.y}, {x: infiniteX, y: infiniteY}, {x: newEnemy.x, y: newEnemy.y}, .3)) {
                newEnemies.push(newEnemy);
            }
        }

        return newEnemies;
    }

    protected shoot(): void {

        super.shoot();

        let enemies: Enemy[] = [];

        let enemiesNumber = 1;
        let enemiesCounter = 0;

        if (this.fixedTarget) {
            if (this.followedEnemy) {
                enemies.push(this.followedEnemy);
                if (this.followedEnemy === this.enemiesWithinRange[0]) {
                    enemiesCounter++;
                }
            } else {
                enemies.push(this.enemiesWithinRange[0]);
                enemiesCounter++;
            }
        } else {
            enemies.push(this.enemiesWithinRange[0]);
            enemiesCounter++;
        }

        while (enemies.length < enemiesNumber) {

            if (this.enemiesWithinRange[enemiesCounter] ) {
                enemies.push(this.enemiesWithinRange[enemiesCounter]);
                enemiesCounter++;
            } else {
                break;
            }
        }
        
        if (enemies[0].life > 0) {
            this.engine.addLaserRay(this, enemies);
        } else {
            this.readyToShoot = true;
        }
    }
}
